import { Routes, Route, Navigate } from 'react-router-dom'

import { WhatsAppProvider } from './context/WhatsAppProvider'

import CookieConsent from './components/CookieConsent'
import ProtectedRoute from './components/ProtectedRoute'

import LandingPage from './pages/LandingPage'

import Login from './pages/Login'

import LeadsPage from './pages/LeadsPage'



function App() {

  return (

    <WhatsAppProvider>
      <CookieConsent />

      <Routes>

        <Route path="/" element={<LandingPage />} />

        <Route path="/login" element={<Login />} />

        <Route

          path="/leads"

          element={

            <ProtectedRoute>

              <LeadsPage />

            </ProtectedRoute>

          }

        />

        <Route path="/admin" element={<Navigate to="/leads" replace />} />

      </Routes>

    </WhatsAppProvider>

  )

}



export default App

